var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartContainer',_vm._b({attrs:{"is-empty":_vm.total <= 0,"summary":_vm.summary,"custom-legend":true,"legends":_vm.legends,"container-width":300}},'ChartContainer',_vm.$attrs,false),[_c('PieChart',{ref:"chart",attrs:{"chart-dataset":_vm.dataset,"options":_vm.options,"hide-legend":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }